export default "__VITE_ASSET__52bd6a1b__"